import type { ProductionReason } from "./models";

// Derive from the persisted code, never from array position or translated name.
export function shortReasonCode(code: string) {
  const match = /^DT-(0[1-5])-(\d{2})$/.exec(code);
  return match ? String(Number(match[1]) * 100 + Number(match[2])) : code;
}
const normalize = (text: string) => text.toLocaleLowerCase("tr").normalize("NFKD").replace(/[\u0300-\u036f]/g, "").replace(/ı/g, "i").replace(/[^a-z0-9]/g, "");
export function searchDowntimeReasons(reasons: ProductionReason[], query: string) {
  const term = normalize(query);
  return reasons.filter(r => r.category === "DOWNTIME" && (!term || normalize(`${shortReasonCode(r.code)} ${r.code} ${r.name} ${r.groupName ?? ""}`).includes(term)))
    .sort((a,b) => Number(shortReasonCode(b.code) === query.trim()) - Number(shortReasonCode(a.code) === query.trim()) || shortReasonCode(a.code).localeCompare(shortReasonCode(b.code), "tr", {numeric:true}));
}
